module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/points/point_11-2c0413d55ea06cf30832ef0758f3410d.svg";